jQuery(document).ready(function($) {
    // Mobile Menu
    $(document).on('click', '.js-menu-mobile', function(e) {
        e.preventDefault();
        $('body').toggleClass('menu-mobile--open');
    });

    $(document).on('click', '.menu-mobile__overlay', function(e) {
        e.preventDefault();
        $('body').removeClass('menu-mobile--open');
    });

    $(document).on('click', '.js-mm-nav-item', function(e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass('mm-nav__prev')) {
            $this.closest('.active--hidden').removeClass('active--hidden');
        } else {
            $this.parents('.mm-nav__links').addClass('active--hidden');
        }
        $this.closest('.menu-mobile__nav-item').toggleClass('active');
    });
    
    if ($(window).width() <= 1024) {
        // ✅ Featured banner slick
        $('#shopify-section-template--26052761911633__featured_banner_DmtnQD .bwp-widget-banner .wpbingo-section__inner .wpbingo-section__content .row--banners').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
        if ($(window).width() <= 767) {
            $('#shopify-section-template--26052761911633__featured_policy_dKbKjd .bwp-widget-policy .row--banners').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 601,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }

    }
    $(".title-footer").click(function() {

        var content = $(this).next(".footer-block");

        // Pehle sab close karo + active class hatao
        $(".footer-block").not(content).slideUp();
        $(".title-footer").not(this).removeClass("active");

        // Is clicked wale par active class toggle karo
        $(this).toggleClass("active");

        // Apna content open/close karo
        content.slideToggle();
    });
    const targets = [
    '.back_in_stock-form',
    '.ask_a_question-form',
    '.delivery_return-content',
    '.product_share-content'
  ];

  function toggleBodyClass() {
    const hasActive = targets.some(selector => $(selector).hasClass('active'));
    $('body').toggleClass('custom-code', hasActive);
  }

  // MutationObserver to detect class changes
  targets.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      new MutationObserver(toggleBodyClass).observe(element, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  });

  toggleBodyClass();
});

